import React  from 'react';
import PropTypes from 'prop-types';
import { courseBuilderConstants } from '../../../../utils/races/CourseBuilderConstants';
import { StdCourseGroup } from './StdCourseGroup';
import { StdCourseItem, itemWidth, transpose } from './StdCourseItem';

export const TriSwimCycleTab = ({selectedStdCourses, onStdCourseToggled, t}) => {

  const buildGroups = () => {
    const courseGroups = courseBuilderConstants(t).STANDARD_COURSES['tri-cycle-swim'];

    if (!courseGroups || courseGroups.length < 3) {
      return <div>{t('Error: no known courses for TriSwimCycle')}</div>
    }

    return (
      <div>
        {buildGroup(courseGroups[0], 1)}
        {buildGroup(courseGroups[1], 2)}
        {buildGroup(courseGroups[2], 4)}
      </div>
    );
  };

  const buildGroup = (group, numCols) => {
    const items = transpose(group.items || [], numCols).map((item) => {
      const selected = !!selectedStdCourses[item.cpid];
      return (
        <StdCourseItem
          key={item.cpid}
          course={item}
          selected={selected}
          onStdCourseToggled={onStdCourseToggled}
        />
      );
    });
    return (
      <StdCourseGroup
        width={itemWidth * numCols}
        groupTitle={group.groupTitle}>
        {items}
      </StdCourseGroup>
    );
  };

  return (<div>{buildGroups()}</div>);
};

TriSwimCycleTab.propTypes = {
  selectedStdCourses: PropTypes.object.isRequired,
  onStdCourseToggled: PropTypes.func.isRequired
};



/** WEBPACK FOOTER **
 ** ./components/race/create/AddCourses/TriSwimCycleTab.js
 **/